import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBingComponent } from './simple-icons-bing.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBingComponent ],
    exports:      [ SimpleIconsBingComponent ],
    bootstrap:    []
})
export class SimpleIconsBingModule {}
